import Box from "@mui/material/Box";
import {BreadcrumbsComponent} from "../../components/UI/breadcrumb/BreadcrumbComponent";
import React, {useEffect, useState} from "react";
import UploadGroupOfMaterialFileForm from "../../components/UI/cloud/UploadGroupOfMaterialFileForm";
import ModelHeadersTable from "../../components/UI/table/orders/organization/header/ModelHeadersTable";
import AttributesTable from "../../components/UI/table/orders/organization/attributes/AttributesTable";
import JobMetricOrganization from "./settings/JobMetricOrganization";
import JobNameTable from "../../components/UI/table/orders/organization/job/JobNameTable";
import Workers from "../organization/orders/worker/Workers";
import PackagingUnit from "../organization/model-estimate/packaging/PackagingUnit";
import PackagingSet from "../organization/model-estimate/packaging/PackagingSet";
import BasicModels from "../organization/model-estimate/models/BasicModels";
import Customers from "../organization/orders/Customers";
import TypeJobOrganization from "./settings/TypeJobOrganization";
import AddressOrganization from "./settings/AddressOrganization";
import {EditLocalStoragePagesData} from "../../utils/EditLocalStoragePagesData";
import {useLocation} from "react-router-dom";
import TreeViewSettings from "./settings/TreeViewSettings";
import Suppliers from "../organization/orders/Suppliers";
import WorkerService from "../../API/orders/job/WorkerService";
import MaterialCloudSuppliers from "../../API/material-cloud/common/MaterialCloudSuppliers";
import {importArray} from "../../data/ImportArray";
import MaterialGroups from "./settings/MaterialGroups";
import MaterialPageItemModule from "../../components/UI/modul/MaterialPageItemModule";
import WarehouseNameTable from "../../components/UI/table/settings/WarehouseNameTable";
import ModelsSetting from "../organization/model-estimate/models/ModelsSetting";
import {constantsErrorMessages} from "../../Constants";
import ModalAlert from "../../components/UI/table/customer-detales/ModalAlert";
import Profile from "./settings/userSettings/Profile";
import OrganizationCustomerService from "../../API/orders/orders/organization/OrganizationCustomerService";
import Personalization from "./settings/userSettings/Personalization";
import CustomerSettings from "./settings/userSettings/CustomerSettings";
import RulesModifyingOptimization
    from "../organization/optimization/rulesmodifyingoptimization/RulesModifyingOptimization";
import SetupStages from "./settings/SetupStages";
import ThemeHelp from "./settings/ThemeHelp";
import HelpSetting from "./settings/HelpSetting";
import Currency from "./settings/Currency";
import CurrenciesNationalBank from "./settings/CurrenciesNationalBank";
import Unit from "./settings/Unit";
import Manufacturer from "./settings/Manufacturer";
import Samples from "../customer/samples/samples/Samples";
import SamplesGroups from "../customer/samples/groups/SamplesGroups";
import SamplesEdges from "../customer/samples/SamplesEdges";
import UserRolesAdmin from "./settings/UserRolesAdmin";
import AllUsers from "./settings/AllUsers";
import RelatedUsers from "./settings/RelatedUsers";
import RatingTable from "./settings/RatingTable";
import VacancyTable from "./settings/VacancyTable";
import NewsSettings from "./settings/NewsSettings";
import Picture from "./settings/Picture";
import Files from "./settings/Files";
import Folders from "./settings/Folders";
import OrganizationEdges from "./settings/OrganizationEdges";
import FileDownloadController from "../../API/organization/FileDownloadController";
import {ClearCache} from "./settings/СlearСache";
import DetailModels from "./settings/DetailModels";
import ErrorsTable from "./settings/ErrorsTable";
import SelcoFileFields from "./settings/SelcoFileFields";
import Postprocessors from "./settings/Postprocessors";
import Machines from "./settings/Machines";
import ButtonExport from "../../components/UI/button/ButtonExport";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import {Typography} from "@mui/material";
import {SETTINGS_TYPES} from "../../data/SettingsType";
import FavoriteOrganization from "./settings/FaforiteOrganization";
import Composition from "./settings/Сomposition";
import Modules from "./settings/Modules";
import CompositionMedia from "./settings/CompositionMedia";
import CompositionPictures from "./settings/CompositionPictures";
import CompositionTextures from "./settings/CompositionTextures";
import ButtonCreate from "../../components/UI/button/ButtonCreate";
import ModalConfirm from "../../components/UI/modal/ModalConfirm";
import MaterialWarehouseService from "../../API/orders/warehouse/material/MaterialWarehouseService";
import {isKuhniVersoMebelDomain, KUHNI_HIDDEN_CUSTOMER_SETTINGS} from "../../utils/isKuhniVersoMebelDomain";

const Settings = ({stage, setStage, profile}) => {
    const pathname = useLocation().pathname
    const [activeSetting, setActiveSetting] = useState("profile")
    const [expandedItems, setExpandedItems] = React.useState([]);
    const [alertData, setAlertData] = useState({});
    const [profileSettings, setProfileSettings] = useState({})
    const [workers, setWorkers] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [collapse, setCollapse] = useState(false)
    const [isPaperSelection, setIsPaperSelection] = useState(false)
    const [modalConfirm, setModalConfirm] = useState(false)

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    const handleCollapseChange = (value) => {
        setCollapse(value);
        EditLocalStoragePagesData(pathname, "collapse", value)
    };
    const handleExpandedItemsChange = (event, itemIds) => {
        setExpandedItems(itemIds);
        EditLocalStoragePagesData(pathname, "expanded", itemIds)
    };
    const handleActiveItemsChange = (itemId) => {
        setActiveSetting(itemId);
        EditLocalStoragePagesData(pathname, "settingName", itemId)
        setIsPaperSelection(false)
    };

    let userRoles = {
        type: "unknown",
        name: ""
    };

    if (profile?.userRoles) {
        profile.userRoles.forEach(el => {
            switch (el.name) {
                case "ROLE_SYSTEM_ADMIN":
                case "ROLE_ADMIN":
                    userRoles = {
                        type: "admin",
                        name: "Настройки системы"
                    };
                    break;
                case "ROLE_ORGANIZATION_SUPER_USER":
                case "ROLE_ORGANIZATION_USER_SETTINGS":
                    userRoles = {
                        type: "organization",
                        name: "Настройки организации"
                    };
                    break;
                case "ROLE_CUSTOMER_USER_SETTINGS":
                case "ROLE_CUSTOMER_CREATOR":
                    userRoles = {
                        type: "customer",
                        name: "Настройки заказчика"
                    };
                    break;
                case "ROLE_CUSTOMER_USER":
                    userRoles = {
                        type: "customerUser ",
                        name: "Настройки заказчика"
                    };
                    break;
                case "ROLE_ONE_ORGANIZATION_USER":
                    userRoles = {
                        type: "organizationUser ",
                        name: "Настройки заказчика"
                    };
                    break;
                default:
                    break;
            }
        });
    }

    useEffect(() => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData'))

        const settingsData = pagesData && pagesData[pathname] || {
            settingName: "profile",
            expanded: []
        }

        let {settingName, expanded, collapse} = settingsData
        if (isKuhniVersoMebelDomain() && KUHNI_HIDDEN_CUSTOMER_SETTINGS.includes(settingName)) {
            settingName = "profile"
        }
        setActiveSetting(settingName)
        setExpandedItems(expanded)
        setCollapse(collapse)

        OrganizationCustomerService.profileSettings().then(function (response) {
            setProfileSettings(response.data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            })

        {
            userRoles?.type === "organization" && WorkerService.getWorkers().then(function (response) {
                setWorkers(response.data);
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        userRoles?.type === "organization" && MaterialCloudSuppliers.get().then(function (response) {
            setSuppliers(response.data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const handleClose = () => {
        setModalConfirm(false)
    }

    const handleConfirm = () => {
        MaterialWarehouseService.sendToAllArchive()
            .then(function () {
                handleModalAlert("Данные успешно обновлены", 'success')
                handleClose();
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent page={"Настройки"} path={[{name: "Главная", href: "/"}]}/>
            <Box sx={{display: "flex", gap: "50px"}}>
                <Box> {collapse ?
                    <Box sx={{width: "30px", cursor: "pointer"}} onClick={() => handleCollapseChange(false)}>
                        <DoubleArrowIcon
                            sx={{color: (theme) => theme.palette.primary.dark}}
                        />
                        <Typography
                            sx={{
                                writingMode: "vertical-rl",
                                color: (theme) => theme.palette.primary.dark,
                                fontWeight: "800",
                                whiteSpace: "nowrap",
                            }}>{activeSetting === "settings" ? userRoles.name : SETTINGS_TYPES[activeSetting]}</Typography>

                    </Box> :
                    <Box sx={{minHeight: 352, minWidth: 300}}>
                        <Box sx={{display: "flex", cursor: "pointer"}} onClick={() => handleCollapseChange(true)}>
                            <DoubleArrowIcon
                                sx={{
                                    color: (theme) => theme.palette.primary.dark,
                                    transform: "rotate(180deg)",
                                }}/>
                            <Typography
                                sx={{
                                    color: (theme) => theme.palette.primary.dark,
                                    fontWeight: "800",
                                }}>{activeSetting === "settings" ? userRoles.name : SETTINGS_TYPES[activeSetting]}</Typography>
                        </Box>
                        <Box sx={{
                            height: isPaperSelection ? `calc(100vh - 330px)` : `calc(100vh - 250px)`,
                            overflowY: 'auto'
                        }}>
                            <TreeViewSettings
                                activeSetting={activeSetting}
                                expandedItems={expandedItems}
                                handleExpandedItemsChange={handleExpandedItemsChange}
                                handleActiveItemsChange={handleActiveItemsChange}
                                userRoles={userRoles}
                                stage={stage}/>
                        </Box>
                    </Box>}
                </Box>
                <Box>
                    {(() => {
                        switch (activeSetting) {
                            case "profile":
                                return <Profile
                                    data={profileSettings} setData={setProfileSettings}
                                    handleModalAlert={handleModalAlert}/>
                            case "personalization":
                                return <Personalization
                                    role={userRoles.type}
                                    handleModalAlert={handleModalAlert}>
                                </Personalization>
                            case "customerSettings":
                                return <CustomerSettings handleModalAlert={handleModalAlert}></CustomerSettings>
                            case "generalSettings":
                                return <CustomerSettings
                                    handleModalAlert={handleModalAlert}
                                    organization={true}
                                    stage={stage}></CustomerSettings>
                            case "setupStages":
                                return <SetupStages
                                    handleModalAlert={handleModalAlert}
                                    stage={stage}
                                    handleActiveItemsChange={handleActiveItemsChange}
                                    setStage={setStage}>
                                </SetupStages>
                            case "relatedUsers":
                                return <RelatedUsers
                                    handleModalAlert={handleModalAlert} itemId={"relatedUsers"}/>;
                            case "favorite-organization":
                                return <FavoriteOrganization
                                    handleModalAlert={handleModalAlert} itemId={"favorite-organization"}/>;
                            //Склад
                            case "warehouseName":
                                return <WarehouseNameTable handleModalAlert={handleModalAlert}
                                                           itemId={"warehouseName"}/>;
                            case "imports":
                                return (
                                    <Box sx={{display: "flex", flexDirection: "column", gap: "5px"}}>
                                        {importArray.slice(0, 3).map(el => {
                                            return <UploadGroupOfMaterialFileForm
                                                key={el.id}
                                                label={'Отправить'}
                                                uploadData={el}
                                                multiple={false}
                                                handleModalAlert={handleModalAlert}
                                            />
                                        })}
                                    </Box>
                                );
                            case "exports":
                                return (
                                    <Box sx={{display: "flex", flexDirection: "column", gap: "15px"}}>
                                        <ButtonExport
                                            text={"Экспорт групп"}
                                            width={130}
                                            api={FileDownloadController.exportGroupFile}
                                            handleModalAlert={handleModalAlert}/>
                                        <ButtonExport
                                            text={"Экспорт базы материалов"}
                                            width={215}
                                            api={FileDownloadController.exportMaterialsFile}
                                            handleModalAlert={handleModalAlert}/>
                                        <ButtonExport
                                            text={"Экспорт цен поставщиков"}
                                            width={215}
                                            api={FileDownloadController.exportSupplierMaterialsFile}
                                            handleModalAlert={handleModalAlert}/>
                                        <ButtonCreate
                                            onClick={() => setModalConfirm(true)}
                                            variant="contained"
                                            text={"Отправить остатки в архив"}
                                            width={270}
                                        />
                                    </Box>
                                );
                            case "headers":
                                return <ModelHeadersTable handleModalAlert={handleModalAlert} itemId={"headers"}/>;
                            case "attributes":
                                return <AttributesTable handleModalAlert={handleModalAlert} itemId={"attributes"}/>;
                            //Материалы
                            case "materialGroups":
                                return <MaterialGroups handleModalAlert={handleModalAlert} itemId={"materialGroups"}
                                                       setIsPaperSelection={setIsPaperSelection}/>;
                            case "material":
                                return <MaterialPageItemModule
                                    handleModalAlert={handleModalAlert}
                                    refMaterial={true}
                                    settings={true}
                                    itemId={"material"}
                                    setIsPaperSelection={setIsPaperSelection}
                                />;
                            //Работы
                            case "listJob":
                                return <JobMetricOrganization
                                    handleModalAlert={handleModalAlert} itemId={"listJob"} settings={true}/>;
                            case "listJobName":
                                return <JobNameTable
                                    handleModalAlert={handleModalAlert} itemId={"listJobName"}/>;
                            case "listTypeJob":
                                return <TypeJobOrganization
                                    handleModalAlert={handleModalAlert}
                                    workers={workers}
                                    itemId={"listTypeJob"}/>;
                            case "importJob":
                                return (
                                    <Box sx={{display: "flex", flexDirection: "column", gap: "5px"}}>
                                        {importArray.slice(3, 6).map(el => {
                                                return <UploadGroupOfMaterialFileForm
                                                    key={el.id}
                                                    label={'Отправить'}
                                                    uploadData={el}
                                                    multiple={false}
                                                    handleModalAlert={handleModalAlert}
                                                />
                                            }
                                        )}
                                    </Box>
                                )
                                    ;
                            //Модели
                            case
                            "packagingUnits"
                            :
                                return <PackagingUnit itemId={"packagingUnits"} handleModalAlert={handleModalAlert}/>;
                            case
                            "packagingSets"
                            :
                                return <PackagingSet itemId={"packagingSets"} handleModalAlert={handleModalAlert}/>;
                            case
                            "basicModels"
                            :
                                return <BasicModels handleModalAlert={handleModalAlert} itemId={"basicModels"}/>;
                            case
                            "detailModels"
                            :
                                return <DetailModels handleModalAlert={handleModalAlert} itemId={"detailModels"}
                                                     setIsPaperSelection={setIsPaperSelection}/>;
                            case
                            "modelEdges"
                            :
                                return <OrganizationEdges
                                    handleModalAlert={handleModalAlert}
                                    itemId={"modelEdges"}
                                    model={true}/>;
                            case
                            "models"
                            :
                                return <ModelsSetting itemId={"models"} handleModalAlert={handleModalAlert}/>;
                            case "importModels":
                                return (
                                    <Box sx={{display: "flex", flexDirection: "column", gap: "5px"}}>
                                        {importArray.slice(6, 11).map(el => {
                                            return <UploadGroupOfMaterialFileForm
                                                key={el.id}
                                                label={'Отправить'}
                                                uploadData={el}
                                                multiple={(el.id === 7 || el.id === 10) ? false : true}
                                                handleModalAlert={handleModalAlert}
                                            />
                                        })}
                                    </Box>
                                );
                            //Работники
                            case
                            "workers"
                            :
                                return <Workers itemId={"workers"} handleModalAlert={handleModalAlert}/>;
                            //Заказчики
                            case
                            "organizationCustomers"
                            :
                                return <Customers itemId={"organizationCustomers"}
                                                  handleModalAlert={handleModalAlert}/>;
                            //Поставщики
                            case
                            "organizationSuppliers"
                            :
                                return <Suppliers handleModalAlert={handleModalAlert} suppliers={suppliers}
                                                  itemId={"organizationSuppliers"}/>;
                            case
                                //Постпроцессоры
                            "machines"
                            :
                                return <Machines handleModalAlert={handleModalAlert}
                                                 itemId={"machines"}/>;
                            case
                                //Постпроцессоры
                            "postprocessors"
                            :
                                return <Postprocessors handleModalAlert={handleModalAlert}
                                                       itemId={"postprocessors"}/>;
                            //АдресаОрганизации
                            case
                            "addressList"
                            :
                                return <AddressOrganization isCustomer={userRoles.type === 'customer'}
                                                            itemId={"addressOrganizationList"}
                                                            handleModalAlert={handleModalAlert}/>;
                            //композиции
                            case
                            "composition"
                            :
                                return <Composition itemId={"composition"}
                                                    handleModalAlert={handleModalAlert}/>;
                            case
                            "modules"
                            :
                                return <Modules itemId={"modules"}
                                                handleModalAlert={handleModalAlert}/>;
                            case
                            "moduleDetails"
                            :
                                return <DetailModels itemId={"moduleDetails"}
                                                     handleModalAlert={handleModalAlert}
                                                     setIsPaperSelection={setIsPaperSelection}/>;
                            case  "compositionEdges"
                            :
                                return <OrganizationEdges
                                    itemId={"compositionEdges"}
                                    handleModalAlert={handleModalAlert}
                                    composition={true}/>;
                            case
                            "compositionMedia"
                            :
                                return <CompositionMedia itemId={"compositionMedia"}
                                                         handleModalAlert={handleModalAlert}/>;
                            case
                            "compositionPictures"
                            :
                                return <CompositionPictures itemId={"compositionPictures"}
                                                            handleModalAlert={handleModalAlert}/>;
                            case
                            "compositionTextures"
                            :
                                return <CompositionTextures itemId={"compositionTextures"}
                                                              handleModalAlert={handleModalAlert}/>;
                            case
                            "rulesModifyingOptimization"
                            :
                                return <RulesModifyingOptimization itemId={"rulesModifyingOptimization"}
                                                                   handleModalAlert={handleModalAlert}/>;
                            case
                            "edgeReserveSettings"
                            :
                                return <OrganizationEdges
                                    itemId={"edgeReserveSettings"}
                                    handleModalAlert={handleModalAlert}/>;
                            case
                            "selcoFileFields"
                            :
                                return <SelcoFileFields
                                    itemId={"selcoFileFields"}
                                    handleModalAlert={handleModalAlert}/>;
                            //Материалы админ
                            case "adminMaterialGroups":
                                return <MaterialGroups handleModalAlert={handleModalAlert} admin={true}
                                                       itemId={"adminMaterialGroups"}
                                                       setIsPaperSelection={setIsPaperSelection}/>;
                            case "adminMaterial":
                                return <MaterialPageItemModule
                                    admin={true}
                                    handleModalAlert={handleModalAlert}
                                    refMaterial={true}
                                    isAddMaterial={true}
                                    pageSize={30}
                                    settings={true}
                                    itemId={"adminMaterial"}
                                    allMaterial={true}
                                    setIsPaperSelection={setIsPaperSelection}
                                />;
                            case "adminImports":
                                return (
                                    <Box sx={{display: "flex", flexDirection: "column", gap: "5px"}}>
                                        {importArray.slice(11, 14).map(el => {
                                            return <UploadGroupOfMaterialFileForm
                                                key={el.id}
                                                label={'Отправить'}
                                                uploadData={el}
                                                multiple={false}
                                                handleModalAlert={handleModalAlert}
                                            />
                                        })}
                                    </Box>
                                );
                            case "adminExports":
                                return (
                                    <Box sx={{display: "flex", flexDirection: "column", gap: "15px"}}>
                                        <ButtonExport
                                            text={"Экспорт групп"}
                                            width={130}
                                            api={FileDownloadController.exportGroupFileAdmin}
                                            handleModalAlert={handleModalAlert}/>
                                        <ButtonExport
                                            text={"Экспорт базы материалов"}
                                            width={215}
                                            api={FileDownloadController.exportMaterialsFileAdmin}
                                            handleModalAlert={handleModalAlert}/>
                                        <ButtonExport
                                            text={"Экспорт цен поставщиков"}
                                            width={215}
                                            api={FileDownloadController.exportSupplierMaterialsFileAdmin}
                                            handleModalAlert={handleModalAlert}/>
                                    </Box>
                                );
                            //Работы админ
                            case "listJobPacking":
                                return <JobMetricOrganization
                                    admin={true} handleModalAlert={handleModalAlert} itemId={"listJobPacking"}
                                    settings={true}/>;
                            case "listJobMilling":
                                return <JobMetricOrganization
                                    admin={true} handleModalAlert={handleModalAlert} itemId={"listJobMilling"}
                                    settings={true}/>;
                            case "listJobEdge":
                                return <JobMetricOrganization
                                    admin={true} handleModalAlert={handleModalAlert} itemId={"listJobEdge"}
                                    settings={true}/>;
                            case "listJobDrilling":
                                return <JobMetricOrganization
                                    admin={true} handleModalAlert={handleModalAlert} itemId={"listJobDrilling"}
                                    settings={true}/>;
                            case "listJobCutting":
                                return <JobMetricOrganization
                                    admin={true} handleModalAlert={handleModalAlert} itemId={"listJobCutting"}
                                    settings={true}/>;
                            //Помощь
                            case "themeHelp":
                                return <ThemeHelp
                                    handleModalAlert={handleModalAlert} itemId={"themeHelp"}/>;
                            case "help":
                                return <HelpSetting
                                    handleModalAlert={handleModalAlert} itemId={"help"}/>;
                            //Новости
                            case "themeNews":
                                return <ThemeHelp
                                    handleModalAlert={handleModalAlert} itemId={"themeNews"}/>;
                            case "news":
                                return <NewsSettings
                                    handleModalAlert={handleModalAlert} itemId={"news"}/>;
                            //Акции
                            case "themePromotion":
                                return <ThemeHelp
                                    handleModalAlert={handleModalAlert} itemId={"themePromotion"}/>;
                            case "promotion":
                                return <NewsSettings
                                    handleModalAlert={handleModalAlert} itemId={"promotion"}/>;
                            //Изображения
                            case "picture":
                                return <Picture
                                    handleModalAlert={handleModalAlert} itemId={"picture"}/>;
                            //Файлы
                            case "files":
                                return <Files
                                    handleModalAlert={handleModalAlert} itemId={"files"}/>;
                            case "folders":
                                return <Folders
                                    handleModalAlert={handleModalAlert} itemId={"folders"}/>;
                            //валюта
                            case "currency":
                                return <Currency
                                    handleModalAlert={handleModalAlert} itemId={"currency"}/>;
                            case "currenciesNationalBank":
                                return <CurrenciesNationalBank
                                    handleModalAlert={handleModalAlert} itemId={"currenciesNationalBank"}/>;
                            case "unit":
                                return <Unit
                                    handleModalAlert={handleModalAlert} itemId={"unit"}/>;
                            case "adminSuppliers":
                                return <Suppliers
                                    handleModalAlert={handleModalAlert} admin={true} itemId={"adminSuppliers"}/>;
                            case "adminManufacturer":
                                return <Manufacturer
                                    handleModalAlert={handleModalAlert} admin={true} itemId={"adminManufacturer"}/>;
                            //шаблоны
                            case "systemSamples":
                                return <Samples admin={true} system={true} handleModalAlert={handleModalAlert}
                                                itemId={"systemSamples"} settings={true}
                                                handleActiveItemsChange={handleActiveItemsChange}/>;
                            case "systemSamplesGroup":
                                return <SamplesGroups system={true} handleModalAlert={handleModalAlert}
                                                      itemId={"systemSamplesGroup"}
                                                      settings={true}/>
                            case "systemSamplesEdges":
                                return <SamplesEdges system={true} handleModalAlert={handleModalAlert}
                                                     itemId={"systemSamplesEdges"} settings={true}/>
                            case "userRoles":
                                return <UserRolesAdmin handleModalAlert={handleModalAlert}
                                                       itemId={"userRoles"}/>
                            case "allOrganizations":
                                return <AllUsers
                                    handleModalAlert={handleModalAlert}
                                    itemId={"allOrganizations"}/>
                            case "allCustomers":
                                return <AllUsers
                                    handleModalAlert={handleModalAlert}
                                    itemId={"allCustomers"}/>
                            case "allUsers":
                                return <AllUsers
                                    handleModalAlert={handleModalAlert}
                                    itemId={"allUsers"}/>
                            case "rating":
                                return <RatingTable
                                    handleModalAlert={handleModalAlert}
                                    itemId={"rating"}/>
                            case "errors":
                                return <ErrorsTable
                                    handleModalAlert={handleModalAlert}
                                    itemId={"errors"}/>
                            case "vacancy":
                                return <VacancyTable
                                    handleModalAlert={handleModalAlert}
                                    itemId={"vacancy"}/>
                            case "cacheOrders":
                                return <ClearCache
                                    handleModalAlert={handleModalAlert}
                                    itemId={"cacheOrders"}/>
                            case "cacheModels":
                                return <ClearCache
                                    handleModalAlert={handleModalAlert}
                                    itemId={"cacheModels"}/>
                            case "cacheAuthorization":
                                return <ClearCache
                                    handleModalAlert={handleModalAlert}
                                    itemId={"cacheAuthorization"}/>
                            default:
                                return <Box/>;
                        }
                    })()}
                </Box>
            </Box>
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
            <ModalConfirm
                title={"Подтвердить отправку?"}
                modalOpen={modalConfirm}
                handleClose={handleClose}
                handleSubmit={handleConfirm}
                action={"Подтвердить"}/>
        </Box>
    );
};

export default Settings;